export const PREVIEW_BASE = '/preview/:lang'
export const EDITOR_BASE = '/:siteId/:lang'
export const EDIT_BASE = `${EDITOR_BASE}/edit`
export const PAGE_BASE = `${EDIT_BASE}/:page`
